export const IS_ENABLE_GLOBAL_LOADER = true;
